/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL || (typeof window !== "undefined" ? window.location.origin : "");
/* HustleEats Phase 2.B — Tables management (creates table + prints QR).
   The diner-side smart-menu + payer flow lives at /eat/table/:qr_token. */
export default function TablesTab({ venueSlug }) {
  const [tables, setTables] = useState([]);
  const [form, setForm] = useState({ table_number: "", capacity: 4, notes: "" });
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const refresh = async () => {
    const { data } = await axios.get(
      `${API}/api/hustleeats/dining/tables/${venueSlug}`,
      { withCredentials: true },
    );
    setTables(data || []);
  };
  useEffect(() => { refresh(); }, [venueSlug]);

  const createTable = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setMsg(null);
    try {
      const { data } = await axios.post(
        `${API}/api/hustleeats/dining/tables`,
        { venue_slug: venueSlug, ...form },
        { withCredentials: true },
      );
      setMsg({ kind: "ok", text: `Table ${data.table_number} created.` });
      setForm({ table_number: "", capacity: 4, notes: "" });
      refresh();
    } catch (e) {
      setMsg({ kind: "err", text: e?.response?.data?.detail || "Failed." });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ph2-tabbody">
      <h3 className="ph2-h3">Add a table</h3>
      <form onSubmit={createTable} className="he-form">
        <div className="he-form__row">
          <label className="he-form__field">
            <span>Table number</span>
            <input
              type="text"
              required
              value={form.table_number}
              onChange={(e) => setForm({ ...form, table_number: e.target.value })}
              placeholder="e.g. T7"
              data-testid="tbl-num-input"
            />
          </label>
          <label className="he-form__field">
            <span>Capacity</span>
            <input
              type="number"
              min={1}
              max={30}
              value={form.capacity}
              onChange={(e) => setForm({ ...form, capacity: Number(e.target.value) })}
            />
          </label>
        </div>
        <label className="he-form__field">
          <span>Notes (optional)</span>
          <input
            type="text"
            value={form.notes}
            onChange={(e) => setForm({ ...form, notes: e.target.value })}
            placeholder="e.g. Window booth"
          />
        </label>
        <button type="submit" className="he-card__cta" disabled={busy} data-testid="tbl-create-btn">
          {busy ? "Creating…" : "Add table"}
        </button>
      </form>
      {msg && <div className={`he-admin__msg he-admin__msg--${msg.kind}`}>{msg.text}</div>}

      <h3 className="ph2-h3" style={{ marginTop: 32 }}>Tables ({tables.length})</h3>
      <div className="ph2-tables">
        {tables.map((t) => {
          const qrUrl = `${window.location.origin}/eat/table/${t.qr_token}`;
          return (
            <div key={t.id} className="ph2-table" data-testid={`tbl-row-${t.id}`}>
              <div className="ph2-table__num">{t.table_number}</div>
              <div className="ph2-table__cap">cap {t.capacity}</div>
              <div className="ph2-table__qr">
                <a href={qrUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize: 11, color: "var(--he-rust)" }}>
                  Open table QR landing →
                </a>
              </div>
              <div className="ph2-table__active" data-testid={`tbl-active-${t.id}`}>
                {t.active_session_count || 0} active
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
